module.exports = __webpack_public_path__ + "static/img/icon_expand_category_hover.dd44b3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_expand_category_hover.svg
// module id = T1PB
// module chunks = 10